<template>
  <v-container v-hotkey="keymap" id="login_page" class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card class="elevation-12">
          <v-spacer />
          <v-toolbar flat>
            <v-toolbar-title>Вхід в систему</v-toolbar-title>
            <v-spacer />
          </v-toolbar>
          <v-card-text>
            <v-form ref="form" v-model="valid" :lazy-validation="lazy">
              <v-text-field
                v-model="email"
                :rules="emailRules"
                label="E-mail"
                :error-messages="errors"
                required
              />
              <v-text-field
                v-model="password"
                :rules="[required]"
                :type="show1 ? 'text' : 'password'"
                name="input-10-1"
                label="Пароль"
                @click:append="togglePassword = !togglePassword"
              />
            </v-form>
          </v-card-text>
          <v-card-actions :disabled="!valid" id="login_button" @click="login">
            <v-spacer />
            <v-btn color="orange">Увійти</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import statesEnum from '@/enums/statesEnum';
import RestService from '@/services/RestService';
import appMixin from '@/components/Mixin/appMixin';
export default {
  name: 'LoginPage',
  mixins: [appMixin],
  data() {
    return {
      lazy: false,
      valid: true,
      togglePassword: false,
      password: '',
      errors: '',
      required: (value) => !!value || 'Required.',
      min: (v) => v.length >= 8 || 'Min 8 characters',
      email: '',
      show1: false,
      emailRules: [
        (v) => !!v || 'E-mail is required',
        (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
    };
  },
  mounted() {
    const demoToken = this.$store.getters['ConfigStore/getDemoToken'];
    if (demoToken) {
      this.guestLogin(demoToken);
    }
  },
  computed: {
    user() {
      return this.$store.getters['UserStore/getUser'];
    },
    keymap() {
      return {
        enter: this.login,
      };
    },
    routeAfterLogin() {
      return this.$store.getters['ConfigStore/getRouteAfterLogin'];
    },
  },

  methods: {
    async login() {
      try {
        const email = this.email ? this.email.trim() : '';
        const payload = {
          email,
          password: this.password,
        };
        await this.$store.dispatch('UserStore/loginUser', payload);
        this.afterLogin();
      } catch (error) {
        this.errors = 'невірний логін або пароль';
        console.error(error);
      }
    },
    guestLogin(demoToken) {
      this.$store.dispatch('UserStore/createGuestUser', {
        token: demoToken,
      });
      this.afterLogin();
    },
  },
};
</script>
